export default function Radar() {
  return (
    <svg
      className="w-full h-full animate-spin-slow"
      width="504"
      height="503"
      viewBox="0 0 504 503"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="251.869" cy="251.5" r="2.95047" fill="#4CC054" />
      <circle cx="92.2044" cy="276.572" r="1.97934" fill="#4CC054" />
      <circle cx="501.266" cy="324.076" r="1.97934" fill="#4CC054" />
      <circle cx="382.404" cy="26.2932" r="1.97934" fill="#4CC054" />
      <g filter="url(#filter0_f_4_36)">
        <circle
          cx="251.868"
          cy="251.5"
          r="78.8335"
          stroke="#4CC054"
          strokeWidth="2"
        />
      </g>
      <circle
        cx="251.869"
        cy="251.5"
        r="173.842"
        stroke="#022C24"
        strokeWidth="2"
      />
      <g filter="url(#filter1_f_4_36)">
        <circle
          cx="251.869"
          cy="251.5"
          r="246.418"
          stroke="#084A3C"
          strokeWidth="2"
        />
      </g>
      <g filter="url(#filter2_f_4_36)">
        <ellipse
          cx="252"
          cy="251.5"
          rx="80"
          ry="79.5"
          fill="url(#paint0_linear_4_36)"
          fillOpacity="0.05"
        />
        <path
          d="M331.5 251.5C331.5 295.128 295.91 330.5 252 330.5C208.09 330.5 172.5 295.128 172.5 251.5C172.5 207.872 208.09 172.5 252 172.5C295.91 172.5 331.5 207.872 331.5 251.5Z"
          stroke="#181526"
        />
        <path
          d="M331.5 251.5C331.5 295.128 295.91 330.5 252 330.5C208.09 330.5 172.5 295.128 172.5 251.5C172.5 207.872 208.09 172.5 252 172.5C295.91 172.5 331.5 207.872 331.5 251.5Z"
          stroke="url(#paint1_radial_4_36)"
        />
      </g>
      <ellipse cx="251.5" cy="251.5" rx="2.5" ry="1.5" fill="#4CC054" />
      <ellipse cx="92" cy="276.5" rx="2" ry="1.5" fill="#4CC054" />
      <ellipse cx="501.5" cy="324" rx="1.5" ry="2" fill="#4CC054" />
      <ellipse cx="252" cy="68.5" rx="2" ry="2.5" fill="#4CC054" />
      <circle
        cx="251.871"
        cy="251.5"
        r="174.342"
        transform="rotate(165 251.871 251.5)"
        stroke="#181526"
      />
      <circle
        cx="251.871"
        cy="251.5"
        r="174.342"
        transform="rotate(165 251.871 251.5)"
        stroke="url(#paint2_radial_4_36)"
      />
      <g filter="url(#filter3_f_4_36)">
        <circle cx="252.5" cy="251.5" r="247" stroke="#181526" />
        <circle
          cx="252.5"
          cy="251.5"
          r="247"
          stroke="url(#paint3_radial_4_36)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_4_36"
          x="158.935"
          y="158.566"
          width="185.867"
          height="185.867"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="6.55"
            result="effect1_foregroundBlur_4_36"
          />
        </filter>
        <filter
          id="filter1_f_4_36"
          x="0.450684"
          y="0.0820312"
          width="502.836"
          height="502.836"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_4_36"
          />
        </filter>
        <filter
          id="filter2_f_4_36"
          x="168"
          y="168"
          width="168"
          height="167"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_4_36"
          />
        </filter>
        <filter
          id="filter3_f_4_36"
          x="1"
          y="0"
          width="503"
          height="503"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2"
            result="effect1_foregroundBlur_4_36"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4_36"
          x1="226.954"
          y1="173.398"
          x2="379.046"
          y2="391.983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#60F8D8" />
          <stop offset="1" stopColor="#03221C" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_4_36"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(252.031 156.736) rotate(90) scale(105.856 106.522)"
        >
          <stop offset="0.02" stopColor="#116263" stopOpacity="0.66" />
          <stop offset="0.31" stopColor="#61D3D9" stopOpacity="0.66" />
          <stop offset="1" stopColor="#1D2132" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4_36"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(251.939 43.0896) rotate(90) scale(232.806)"
        >
          <stop offset="0.02" stopColor="#116263" stopOpacity="0.66" />
          <stop offset="0.31" stopColor="#61D3D9" stopOpacity="0.66" />
          <stop offset="1" stopColor="#1D2132" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4_36"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(252.596 -43.5188) rotate(90) scale(329.551)"
        >
          <stop offset="0.02" stopColor="#116263" stopOpacity="0.66" />
          <stop offset="0.31" stopColor="#61D3D9" stopOpacity="0.66" />
          <stop offset="1" stopColor="#1D2132" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  )
}
